


export default function menuOpen(){
    const way = "menu/open";
    this.dataSet(way,!this.dataGet(way))
  }
